import {action, makeAutoObservable} from "mobx"
import {ShadowClient} from "../clients/shadow/shadowClient";
import {GatewayEvent} from "../clients/shadow/GatewayEvent";
import {APIUser, ShadowPayload} from "../clients/shadow/interfaces";
import utils from "../utils";
import {Room} from "./RoomStore";
import {UserData} from "../interfaces";

export class UserStore {
    client: ShadowClient;
    users: User[] = [];

    constructor(client: ShadowClient) {
        makeAutoObservable(this, {
            setUsers: action,
        })

        this.client = client
        this.client.on("gateway-event", (event: ShadowPayload) => this.handleGatewayEvent(event))
    }

    handleGatewayEvent(event: ShadowPayload): void {
        switch (event.type) {
            case GatewayEvent.USER_CREATE:
            case GatewayEvent.USER_UPDATE:
            case GatewayEvent.USER_JOIN: {
                this.upsertUser(event.data.user);
                break;
            }
            case GatewayEvent.USER_LEAVE: {
                let user = this.get(event.data.user_id);
                if (user && user.room_id === event.data.room_id) {
                    user.room_id = null;
                }
                break;
            }
            default:
                break;
        }
    }

    get(id: string): User | undefined {
        return this.users.find((user: User) => user.id === id)
    }

    upsertUser(apiUser: APIUser) {
        let user = this.get(apiUser.id)
        if (!user) {
            user = new User(apiUser, this)
            this.users.push(user)
        }
        user.updateFromJson(apiUser)
    }

    getUsersInRoom(roomId: string) {
        return this.users.filter((user: any) => (user.room_id === roomId || user.bot));
    }

    userHasJoined(roomId: string) {
        const clientUser = this.get(this.client.userId);
        return clientUser?.room_id === roomId;
    }

    setUsers(users: APIUser[]) {
        users.forEach((user: any) => this.upsertUser(user));
    }
}

export class User {
    id: string | null = null;
    username: string | null = null;
    store: UserStore;
    room_id: string | null = null;
    avatar: string | null = null;
    login_token: string | null = null;
    online_status: string | null = null;
    typing: boolean = false;
    roles: { name: string }[] = [];
    avatar_url: string | null = null;
    typingTimeout: number | null = null;
    bot: boolean;
    data: UserData;

    constructor(apiUser: APIUser, store: UserStore) {
        this.ownsRoom = this.ownsRoom.bind(this);
        makeAutoObservable(this);
        this.store = store;
        this.updateFromJson(apiUser)
    }

    ownsRoom(room: Room): boolean {
        return this.id === room.owner_id;
    }

    //@todo remove these
    updateFromJson(apiUser: APIUser) {
        Object.assign(this, apiUser)
        this.avatar_url = utils.createAvatarUrl(apiUser.avatar);
    }

    //@todo fix this '_'
    isAdmin_() {
        return this.roles.find(role => role.name === "admin") || this.id === "3";
    }
}
